import { call, put, takeEvery } from 'redux-saga/effects';
import { checkLastRoute } from '../../requests/check_last_route_request';
import { checkLastRouteRequestFailure } from '../actions/check_last_route.actions';
import { CHECK_LAST_ROUTE_REQUEST } from '../constants/check_last_route_and_permission.constants';

function* checkLastRouteRequest({ route }) {
    const { result, error } = yield call(checkLastRoute, route);
    if (result) {
        if (localStorage) {
            localStorage.setItem('last_route', route);
        }
    } else {
        yield put(checkLastRouteRequestFailure(error));
    }
}

export default function* checkLastRouteSaga() {
    yield takeEvery(CHECK_LAST_ROUTE_REQUEST, checkLastRouteRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/check_last_route.saga.js